import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';

import mfNavbarPage from './mfNavbar.page';
import domElementGetter from '../shared/utilities/domElementGetter';

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: mfNavbarPage,
  domElementGetter: () => domElementGetter('renderNavbarId'),
});

export const bootstrap = [reactLifecycles.bootstrap];

export const mount = [reactLifecycles.mount];

export const unmount = [reactLifecycles.unmount];
